import { render, staticRenderFns } from "./page82Mobile.vue?vue&type=template&id=a41930f6&scoped=true&"
import script from "./page82Mobile.vue?vue&type=script&lang=js&"
export * from "./page82Mobile.vue?vue&type=script&lang=js&"
import style0 from "./page82Mobile.vue?vue&type=style&index=0&id=a41930f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a41930f6",
  null
  
)

export default component.exports